/**
 * Default landing route for an authenticated user. Used by sign-in,
 * registration completion, consent acceptance, invite acceptance, billing
 * post-success, merchant switch, and marketing CTAs once the visitor is known
 * to be signed in. Change this in one place to relocate the post-auth home.
 */
export const DEFAULT_AUTHENTICATED_HOME = "/dashboard";
